module.exports = __webpack_public_path__ + "static/media/logo-mega.44b19e2e.png";